module.exports = {
    SELECT_FILTER: 'SELECT_FILTER',
    RECEIVE_STATION_FAVORITES: 'RECEIVE_STATION_FAVORITES',
    RECEIVE_STATION_PICTURES: 'RECEIVE_STATION_PICTURES',
    RECEIVE_STATION_FILES: 'RECEIVE_STATION_FILES',
    RESET_STATION: 'RESET_STATION',
    RECEIVE_ASSOCIATED_SITES: 'RECEIVE_ASSOCIATED_SITES',
    RESET_ASSOCIATED_SITES: 'RESET_ASSOCIATED_SITES',
    RECEIVE_PIEZOMETER: 'RECEIVE_PIEZOMETER',
    RECEIVE_PLUVIOMETER: 'RECEIVE_PLUVIOMETER',
    UPDATE_PIEZOMETER: 'UPDATE_PIEZOMETER',
    DELETE_PIEZOMETER: 'DELETE_PIEZOMETER',
    RECEIVE_EXTERNAL_SITES: 'RECEIVE_EXTERNAL_SITES',
    RECEIVE_SITES_TYPES: 'RECEIVE_SITES_TYPES',
    RECEIVE_FILTERS: 'RECEIVE_FILTERS',
    RECEIVE_FILTER_RESULTS: 'RECEIVE_FILTER_RESULTS',
    RECEIVE_EXPORT_JOBS_TMP: 'RECEIVE_EXPORT_JOBS_TMP',
    RECEIVE_STATION_POINTS_PREL: 'RECEIVE_STATION_POINTS_PREL',
    POLLUTED_SOIL: 'POLLUTED_SOIL',
    INDUSTRIAL_SITE: 'INDUSTRIAL_SITE',
    RECEIVE_PARCEL_AND_SECTION: 'RECEIVE_PARCEL_AND_SECTION',
    FICHE: 'FICHE',
    MAP: 'MAP',
    STATION_LIST: 'STATION_LIST',
    SAMPLE_LIST: 'SAMPLE_LIST',
    NEW: 'new',
    CREATE_FILTER: 'CREATE_FILTER',
    UPDATE_FILTER: 'UPDATE_FILTER',
    DELETE_FILTER: 'DELETE_FILTER',
    RECEIVE_CONTRIBUTOR_LINKS: 'RECEIVE_CONTRIBUTOR_LINKS',
    RECEIVE_FILES_FTP: 'RECEIVE_FILES_FTP',
    RECEIVE_MAP_SITUATIONS: 'RECEIVE_MAP_SITUATIONS',
    RECEIVE_MAP_SITUATIONS_RESULTS: 'RECEIVE_MAP_SITUATIONS_RESULTS',
    STATION_TYPE: {
        POINT_EAU_SOUTERRAINE: 0, // ES
        COURS_D_EAU: 1, // C
        PLAN_D_EAU: 2, // PE
        GRAND_COURS_D_EAU: 3, // GC
        MILIEU_MARIN: 4, // M
        AUTRE_COURS_D_EAU: 5, // AC
        SOURCE: 6, // S
        EAU_DISTRIBUEE: 7, // ED
        EAU_TRAITEE: 8, // ET
        UNITE_DE_DISTRIBUTION: 9,
        UNITE_DE_PRODUCTION: 10,
        RESERVOIR: 11,
        EAUX_DE_BAIGNADE: 12,
        DIAGRAPHIE: 13,
    },
    STATION_QUALITOMETER_NAMES: [
        {
            code: 0,
            name: 'Point eau souterraine',
        }, {
            code: 1,
            name: 'Cours d\'eau',
        }, {
            code: 2,
            name: 'Plan d\'eau',
        }, {
            code: 3,
            name: 'Grand cours d\'eau',
        }, {
            code: 4,
            name: 'Milieu marin',
        }, {
            code: 5,
            name: 'Autre cours d\'eau et ravines',
        }, {
            code: 6,
            name: 'Source',
        }, {
            code: 7,
            name: 'Eau distribuée',
        }, {
            code: 8,
            name: 'Eau traitée',
        }, {
            code: 9,
            name: 'Unité de distribution',
        }, {
            code: 10,
            name: 'Unité de production',
        }, {
            code: 11,
            name: 'Réservoir',
        }, {
            code: 12,
            name: 'Eaux de baignade',
        }, {
            code: 13,
            name: 'Diagraphie',
        },
    ],
    STATION_QUALITOMETER_NAMES_HYDRO: [
        {
            code: 1,
            name: 'Cours d\'eau',
        }, {
            code: 2,
            name: 'Plan d\'eau',
        }, {
            code: 3,
            name: 'Grand cours d\'eau',
        }, {
            code: 4,
            name: 'Milieu marin',
        }, {
            code: 5,
            name: 'Autre cours d\'eau et ravines',
        }, {
            code: 6,
            name: 'Source',
        }, {
            code: 7,
            name: 'Eau distribuée',
        }, {
            code: 8,
            name: 'Eau traitée',
        }, {
            code: 9,
            name: 'Unité de distribution',
        }, {
            code: 10,
            name: 'Unité de production',
        }, {
            code: 11,
            name: 'Réservoir',
        }, {
            code: 12,
            name: 'Eaux de baignade',
        },
    ],
    STATION_PRODUCER: 'Exploitant',
    STATION_NAME: {
        QUALITOMETER: 'QUALITOMETER',
        PLUVIOMETER: 'PLUVIOMETER',
        PIEZOMETER: 'PIEZOMETER',
        HYDROMETRIC_STATION: 'HYDROMETRIC_STATION',
        PRODUCTION_UNIT: 'PRODUCTION_UNIT',
        DISTRIBUTION_UNIT: 'DISTRIBUTION_UNIT',
        INSTALLATION: 'INSTALLATION',
    },

    STATION_NAME_ASSOCIATION: {
        quality: 'QUALITOMETER',
        qualitometer: 'QUALITOMETER',
        piezometry: 'PIEZOMETER',
        piezometer: 'PIEZOMETER',
        hydrometry: 'HYDROMETRIC_STATION',
        hydrometricStation: 'HYDROMETRIC_STATION',
        pluviometry: 'PLUVIOMETER',
        pluviometer: 'PLUVIOMETER',
        productionUnit: 'PRODUCTION_UNIT',
        distributionUnit: 'DISTRIBUTION_UNIT',
        installation: 'INSTALLATION',
        contact: 'CONTACT',
        contributor: 'CONTRIBUTOR',
        resource: 'RESOURCE',
        managementEntity: 'MANAGEMENT_ENTITY',
        cms: 'CMS',
        other: 'other',
        samplePoint: 'SAMPLE_POINT',
    },

    STATION_NAME_ASSOCIATION_REVERSE: {
        1: 'PIEZOMETER',
        2: 'PLUVIOMETER',
        3: 'QUALITOMETER',
        4: 'HYDROMETRIC_STATION',
        5: 'PRODUCTION_UNIT',
        6: 'DISTRIBUTION_UNIT',
        7: 'INSTALLATION',
        8: 'CONTRIBUTOR',
        9: 'RESOURCE',
        10: 'CONTACT',
    },

    STATION_TYPE_NAME: {
        quality: 'quality',
        qualitometer: 'qualitometer',
        piezometry: 'piezometry',
        piezometer: 'piezometer',
        hydrometry: 'hydrometry',
        hydrometricStation: 'hydrometricStation',
        hydrologicalStation: 'hydrologicalStation',
        pluviometry: 'pluviometry',
        pluviometer: 'pluviometer',
        production: 'production',
        productionUnit: 'productionUnit',
        distribution: 'distribution',
        distributionUnit: 'distributionUnit',
        installation: 'installation',
        perimeters: 'perimeters',
        catchment: 'catchment',
        materiel: 'materiel',
        carto: 'carto',
        situation: 'situation',
        agri: 'usageAgri',
        qaptys: 'qaptys',
        observatory: 'observatory',
        aquadb: 'aquadb',
        cce: 'cce',
        resource: 'resource',
        pgsse: 'pgsse',
        exploitation: 'exploitation',
        rpqs: 'rpqs',
        agriculture: 'agriculture',
    },

    STATION_TYPE_NAME_TRONCATE: {
        quality: 'quality',
        piezometry: 'piezo',
        hydrometry: 'hydro',
        pluviometry: 'pluvio',
        installation: 'inst',
    },

    STATIONS_TYPE_NAME: {
        qualitometers: 'qualitometers',
        piezometers: 'piezometers',
        hydrometricStations: 'hydrometricStations',
        installations: 'installations',
        productionUnits: 'productionUnits',
        distributionUnits: 'distributionUnits',
        pluviometers: 'pluviometers',
    },

    LINK_STATION_TYPES: [
        {
            code: 'DIAGRAPHIE',
            name: 'DIAGRAPHIE',
        },
    ],

    STATION_TYPE_CONSTANT: {
        PIEZOMETRY: 1,
        PIEZOMETER: 1,
        piezometry: 1,
        piezometer: 1,

        PLUVIOMETRY: 2,
        PLUVIOMETER: 2,
        pluviometry: 2,
        pluviometer: 2,

        QUALITY: 3,
        QUALITOMETER: 3,
        quality: 3,
        qualitometer: 3,

        HYDROMETRY: 4,
        HYDROMETER: 4,
        hydrometry: 4,
        hydrometricStation: 4,
        HYDROMETRIC_STATION: 4,

        PRODUCTION: 5,
        PRODUCTION_UNIT: 5,
        productionUnit: 5,

        DISTRIBUTION: 6,
        DISTRIBUTION_UNIT: 6,
        distributionUnit: 6,

        INSTALLATION: 7,
        installation: 7,

        CONTRIBUTOR: 8,
        contributor: 8,

        RESOURCE: 9,
        resource: 9,

        CONTACT: 10,
        contact: 10,

        CATCHMENT: 11,
        catchment: 11,

        JOB: 12,
        job: 12,

        /* CAMPAIGN_BOOKMARK_TYPE: {  // id des favoris pour les campagnes
            quality: 13,
            piezometry: 14,
            hydrometry: 15,
            pluviometry: 16,
            installation: 17,
        }, */

        MANAGEMENT_ENTITY: 18, // entité de gestion RPQS (lien_stations)
        managementEntity: 18,
    },

    THRESHOLD_CATEGORIES: {
        SITUATION: 1,
        INFORMATIVE: 2,
        CONTROL: 3,
    },

    THRESHOLD_CATEGORIES_SELECTION: [
        {
            code: 1,
            name: 'Situation',
        }, {
            code: 2,
            name: 'Informatif',
        }, {
            code: 3,
            name: 'Contrôle',
        },
    ],

    FROZEN_CODE_STATUS: '3',

    MISSING_DATA_TIME_LIMIT: {
        INSTALLATION: 120,
        DEFAULT: 72,
    },

    THRESHOLD_CATEGORY: {
        SITUATION: 1,
        INFO: 2,
        CONTROL: 3,
    },

    IS_INITIAL_POINT: 1,
    IS_NOT_INITIAL_POINT: 2, // 2 ou null = pas point initial ; 1 = point initial
}
